module.exports = __webpack_public_path__ + "img/baseball.bb1b8a6c.svg";